module.exports = __webpack_public_path__ + "static/img/daily-cargo-volumes.58e77a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/videodaily/daily-cargo-volumes.png
// module id = OmhL
// module chunks = 1